<template>
    <div class="__em-textarea" :class="{'__em-textarea-readonly':emapmReadonly}">
        <!-- <mt-field :label="caption" :readonly="param.readonly" :value="currentValue" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
        </mt-field> -->
        <mt-cell :title="caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign" >
            <span class="mt-color-grey-lv3 mt-cell-diy-span" style="">{{currentValue}}</span>
        </mt-cell>
        <mt-textarea v-if="!param.readonly" :label="caption" :placeholder="placeholder" rows=3 :maxlength="maxlength" :disabled="param.disabled" :required="param.required" v-model="currentValue" :easycheck="easycheck" type="textarea" :direction="JSONParam.direction"></mt-textarea>
    </div>
</template>
<script>
export default {

    name: 'emTextarea',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: {
            default: ''
        },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            currentValue: this.value || "",
            emapmReadonly:false
            //JSONParam:this.model.JSONParam ? JSON.parse(this.model.JSONParam):{direction:''}
        };
    },

    watch: {
        value(val) {
            this.currentValue = val || "";
        },
        currentValue(val) {
            this.$emit('input', val);
            //debugger
            if(val && document.getElementsByClassName('emapm-form-readonly').length>0){
                this.emapmReadonly = true;
            }else {
                this.emapmReadonly = false;
            }
        }
    },
    computed: {
        JSONParam() {
            var jsonParam = {};
            //debugger
            if(this.model.JSONParam){
                jsonParam = JSON.parse(this.model.JSONParam.replace(/'/g, '"'))
                return jsonParam;
                //debugger
            }else {
                return {direction:''};
            } 
        },
        easycheck() {
            return !!this.param.textareaEasyCheck;
        },
        maxlength() {
            if (this.model.checkSize) {
                return this.model.checkSize + '';
            }
            let maxlength = this.model.dataSize;
            if (this.easycheck) {
                return Math.floor(maxlength / 3) + ''
            }
            return maxlength + '';
        },
        placeholder() {
            if (this.param.placeholder) {
                return this.param.placeholder;
            }
            return '请输入' + this.model.caption;
        },
        param() {
            return this.model.initParam;
        },
        caption() {
            //debugger
            if (this.param.showTitle === false) {
                return '';
            }else if (this.model.JSONParam && JSON.parse(this.model.JSONParam.replace(/'/g, '"')).nolabel){
                return '';
            }else {
                return this.model.caption;
            }
            
        }
    },
};
</script>
<style lang="css">
.__em-textarea textarea[readonly="readonly"] {
    resize: none;
}
.emapm-form.emapm-form-readonly  .mint-cell-group .mint-cell-group-content .emapm-item .__em-textarea  .mint-cell .mint-cell-wrapper{
    align-items:baseline !important;
}
/* .emapm-form.emapm-form-readonly  .mint-cell-group .mint-cell-group-content .emapm-item .__em-textarea.__em-textarea-readonly {
    background-color:#345678;
} */
/* .__em-textarea .mint-cell-wrapper {
    align-items: baseline;
} */
.__em-textarea .mint-textarea .mint-cell-wrapper .mint-cell-value{
    width:100%;
}
.mt-cell-diy-span {
    word-break: break-all;
    /* text-align: right; */
}
</style>


// WEBPACK FOOTER //
// emTextarea.vue?baf8cc68